import { StatusKey } from '@/Enums/Clients/StatusKey.enum';
import { IClientFormData } from '@/Interfaces/Client.interface';

export const CLIENTS_STATUS_LABELS = [
  { name: StatusKey.ALL, label: 'All' },
  { name: StatusKey.ACTIVE, label: 'Active' },
  { name: StatusKey.INACTIVE, label: 'Inactive' },
] as const;

export const STATUS_FILTER_MAP = {
  [StatusKey.ALL]: null,
  [StatusKey.ACTIVE]: true,
  [StatusKey.INACTIVE]: false,
};

export const BASE_TAB_ID = 'clients-filter-tab';

export const DEFAULT_CLIENT: IClientFormData = {
  name: '',
  externalId: '',
  whitelabel: null,
  advertisers: [],
  agencies: [],
  newAdvertisers: [],
  newAgencies: [],
};
